var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Form',{attrs:{"req":_vm.req},on:{"update:req":function($event){_vm.req=$event}}})}
var staticRenderFns = []

export { render, staticRenderFns }